<script setup lang="ts">
import { inject, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import giftaidItBlack from '@/assets/images/giftaidit-black.svg'

const store = useStore()
const rootSiteDomain = inject<string>(
  'rootSiteDomain',
  'https://www.swiftaid.co.uk'
)

onBeforeMount(() => {
  window.addEventListener('beforeunload', logout)
})

const logout = () => {
  store.dispatch('auth0Logout', rootSiteDomain)
}
</script>

<template>
  <div
    class="sa-auth-step sa-auth-status-page"
    data-testid="close-account-confirm"
  >
    <header class="sa-auth-step__header">
      <img
        :src="giftaidItBlack"
        class="sa-auth-status-page__mark"
        alt="Gift Aid"
        width="142"
        height="48"
      />
      <h1 class="sa-auth-step__title">
        {{ $t('ManageAccount.CloseAccountConfirm.Header') }}
      </h1>
      <p class="sa-auth-step__lead">
        {{ $t('ManageAccount.CloseAccountConfirm.Para1') }}
      </p>
    </header>

    <p class="sa-auth-close-confirm__note">
      {{ $t('ManageAccount.CloseAccountConfirm.Para2') }}
      <a
        :href="`${rootSiteDomain}/legal/privacy`"
        class="sa-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('ManageAccount.CloseAccountConfirm.Para2LinkText') }}
      </a>
    </p>

    <div class="sa-auth-status-page__status">
      <button
        type="button"
        class="sa-btn-primary sa-auth-form__submit"
        @click.prevent="logout"
      >
        {{ $t('ManageAccount.CloseAccountConfirm.Button') }}
      </button>
    </div>
  </div>
</template>
